import { useRef } from 'react'

import { RefreshTokenServiceAPI } from '../../services/RefreshTokenService/index.api'

const useRefreshTokenService = (): RefreshTokenServiceAPI => {
   const refreshTokenServiceRef = useRef(new RefreshTokenServiceAPI())

   return refreshTokenServiceRef.current
}

export { useRefreshTokenService }
